export default {"src":"/_next/static/media/well_being.24fe8fb2.svg","height":153,"width":217,"blurWidth":0,"blurHeight":0};